import PropTypes from 'prop-types';
import moment from 'moment';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from "react";
import { Typography, message, Spin, Empty, Row, Col } from "antd";
import { CampaignDetails } from "../../../Api/Services/CampaignApiServices"
import { useExcryptedNavigation } from '../Filters/FilterConditions';

const { Text } = Typography;

const NoteDetails = ({ displayData, refreshTrigger, tabKey }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    const { ExcryptedNavigation } = useExcryptedNavigation()
    const ViewDetailPage = (id, entity) => {
        ExcryptedNavigation("Nav", id, entity, history, dispatch, null, null)
    }
    const [childCaseData, setChildCaseData] = useState([])
    async function getCaseData1(params) {
        try {
            const competitionArray = params.split(',').map(item => Number(item.trim()));
            const results = await Promise.all(
                competitionArray.map(async (competitionId) => {
                    const Response = await CampaignDetails(competitionId)
                    const DataSet = {
                        ...Response?.data,
                        casePresent: Response?.allow ? "Yes" : "No",
                    }
                    return DataSet;
                })
            );
            setChildCaseData(results);
        } catch (error) {
            message.error(error);
        }
    }
    useEffect(() => {
        if (displayData?.childCampaign) {
            if (refreshTrigger === tabKey) {
                getCaseData1(displayData?.childCampaign)
            }
        }
        else {
            setChildCaseData([])
        }
    }, [displayData, refreshTrigger, tabKey])
    function formatDate(value, profile) {
        if (!value) return "";
        const format = profile?.dateFormate && profile?.dateFormate !== "" ? profile?.dateFormate : "YYYY-MM-DD";
        return moment(value).format(format);
    }
    return (
        <>
            <Row gutter={30}>
                {childCaseData ? (childCaseData?.length > 0 ?
                    childCaseData?.map((item, index) => {
                        return (
                            <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                <div className='RightSide-DataShadow' key={index} style={{ marginBottom: 15 }}>
                                    <div className={`user-info_image ${item?.casePresent === "Yes" && "ListNavigate"}`}
                                        role="button" style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }}
                                        tabIndex={0}
                                        onClick={item?.casePresent === "Yes" ? () => ViewDetailPage(item?.campaignId, "CAMPAIGN") : undefined}
                                        onKeyDown={(event) => {
                                            if (event.key === 'Enter' || event.key === ' ') {
                                                ViewDetailPage(item?.campaignId, "CAMPAIGN");
                                            }
                                        }}
                                    >
                                        <span className='list_span_Tag' style={{ flexShrink: 0, }}>
                                            {item?.campaignName?.slice(0, 1).toUpperCase()}
                                        </span>
                                        <figcaption style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            overflow: "hidden", // 👈 keeps ellipsis responsive
                                        }}>
                                            <div style={{
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                            }} title={item?.campaignName}> {item?.campaignName}</div>
                                            <div style={{
                                                fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                            }} title={item?.campaignStatus}>{item?.campaignStatus}</div>
                                        </figcaption>
                                    </div>
                                    <Row gutter={30}>
                                        <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                            {(item?.startDate && item?.startDate !== "") ?
                                                <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Start Date</Text> <br />
                                                    <Text>{formatDate(item?.startDate, profile)}</Text>
                                                </div> : <></>}
                                        </Col>
                                        <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                            {(item?.endDate && item?.endDate !== "") ?
                                                <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>End Date</Text> <br />
                                                    <Text >{formatDate(item?.endDate, profile)}</Text>
                                                </div> : <></>
                                            }
                                        </Col>
                                    </Row>
                                    <Row gutter={30}>
                                        <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                            {(item?.campaignType && item?.campaignType !== "") ?
                                                <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Campaign Type</Text> <br />
                                                    <Text>{item?.campaignType}</Text>
                                                </div> : <></>}</Col>
                                    </Row>
                                    <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Campaign Owner</Text> <br />
                                        <Text ><div className={`user-info_image ${(Role === "Administrator" || profile.userId === item?.campaignOwner) && "ListNavigate"}`}
                                            role="button" style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }}
                                            tabIndex={0}
                                            onClick={(Role === "Administrator" || profile.userId === item?.campaignOwner) ? () => item?.campaignOwner && ViewDetailPage(item?.campaignOwner, "USER") : undefined}
                                            onKeyDown={(event) => {
                                                if (event.key === 'Enter' || event.key === ' ') {
                                                    ViewDetailPage(item?.campaignOwner, "USER");
                                                }
                                            }}
                                        >  {item?.campaignOwnerProfilePic !== null && item?.campaignOwnerProfilePic
                                            !== undefined && item?.campaignOwnerProfilePic !== "" ?
                                            <figure>
                                                <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={item?.campaignOwnerProfilePic} alt="" />
                                            </figure>
                                            :
                                            <span className='list_span_Tag UserIcon' style={{ flexShrink: 0, }}>
                                                {item?.campaignOwnerFirstName?.slice(0, 1).toUpperCase()}
                                            </span>
                                            }
                                            <figcaption style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                overflow: "hidden", // 👈 keeps ellipsis responsive
                                            }}>
                                                <div style={{
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }} title={`${item?.campaignOwnerFirstName} ${item?.campaignOwnerLastName}`}> {item?.campaignOwnerFirstName}  {item?.campaignOwnerLastName}</div>
                                                <div style={{
                                                    fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }} title={item?.campaignOwnerEmail}>{item?.campaignOwnerEmail}</div>
                                            </figcaption>
                                        </div></Text>
                                    </div>
                                </div>
                            </Col>
                        )
                    }) :
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                        <div style={{ padding: "10%" }}>
                            <Empty />
                        </div></Col>)
                    :
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                        <div className="spin">
                            <Spin />
                        </div></Col>
                }
            </Row>
        </>
    );
};
NoteDetails.propTypes = {
    displayData: PropTypes.object.isRequired,
    refreshTrigger: PropTypes.string.isRequired,
    tabKey: PropTypes.string.isRequired,
};
export default React.memo(NoteDetails)
